import React from "react";
import EventShowcaseCard from "./EventShowcaseCard";
import EventShowcaseData from "./EventShowcaseData";
import Navigation from "Components/Nav/Nav";
import styles from "./EventsShowcase.module.css";

const EventShowcases = () => {
  return (
    <>
      <Navigation />
      <section style={{ padding: "1rem" }}>
        <h1 className={styles.eventTitle}>
          ACBC <span className={styles.spanText}>EVENTS</span>
        </h1>
        {EventShowcaseData.map((item, i) => (
          <EventShowcaseCard key={i} {...item} />
        ))}
      </section>
    </>
  );
};

export default EventShowcases;
